<template>
  <div class="content work_wrapper search_content simple_content">
    <v-row class="search_box">
      <v-col>
        <topNav></topNav>
      </v-col>
    </v-row>
    <div class="md_title marl32 mart24">检索方式</div>
    <v-row class="tabs_wrapper grey_tabs special">
      <v-col sm="12" md="12">
        <v-tabs @change="handleChange" v-model="activeKey">
          <v-tab key="1" style="padding: 0 12px">简单检索</v-tab>
          <v-tab key="2" style="padding: 0 12px" v-if="!iphone">高级检索</v-tab>
          <v-tab key="3" style="padding: 0 12px" >图像检索</v-tab>
          <v-tab key="4" style="padding: 0 12px" >语义检索</v-tab>
          <v-tab-item key="1">
            <easySearch></easySearch>
          </v-tab-item>
          <v-tab-item key="2">
           <advancedSearch></advancedSearch>
          </v-tab-item>
          <v-tab-item key="3">
            <imageSearch></imageSearch>
          </v-tab-item>
          <v-tab-item key="5">
            <semanticRetrieve></semanticRetrieve>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
</div>
</template>

<script>
import  mix from './mix.js'
import {getPnc} from "../../../assets/js/methods";
export default {
  mixins:[mix],
  data() {
    return {
      activeKey: 0,
      country:[],
      rspnation:
          "cn;;;jp;;;us;;;kr;;;wo;;;de;;;gb;;;fr;;;ca;;;tw;;;au;;;es;;;ru;;;zn;;;at;;;it;;;in;;;br;;;eu;;;se;;;no;;;ch;;;fi;;;dk;;;pl;;;mx;;;nl;;;be;;;il;;;hk;;;za;;;my;;;hu;;;pt;;;ar;;;ua;;;cz;;;id;;;nz;;;sg;;;gr;;;ro;;;ea;;;ie;;;tr;;;cl;;;sh;;;vn;;;ph;;;si;;;pe;;;bg;;;hr;;;sk;;;co;;;lu;;;ap;;;uy;;;cy;;;rs;;;md;;;th;;;tn;;;ec;;;lt;;;eg;;;oa;;;ma;;;mn;;;mo;;;cr;;;lv;;;ee;;;gt;;;is;;;cu;;;mc;;;ge;;;do;;;jo;;;pa;;;sa;;;gc;;;sm;;;me;;;sv;;;ni;;;zw;;;hn;;;bn;;;zm;;;dz;;;mt;;;bh;;;py;;;ke;;;mw;;;ve;;;tj;;;ae;;;bo;;;ba;;;kz;;;bd;;;iq;;;by;;;la;;;kh;;;sy;;;uz;;;az;;;mk;;;tm;;;am;;;kg;;;tt",
      filterList1:[],
      types: [],
      cList:[],
      dialog: false,
      typeList:[],
      isAllCountry: false,
      isIndeter1: false,
      selectedCountry: [],
      multiple: false,
      list: [],
    }
  },
  created() {
    if (
        this.$vuetify.breakpoint.name == "sm" ||
        this.$vuetify.breakpoint.name == "xs"
    ) {
      this.iphone = true;
    } else {
      this.iphone = false;
    }
    this.activeKey = this.searchType || 0
    if(this.searchType&&this.searchType == 0) {
      this.inputKey = this.searchKey
    }
    if(this.searchType&&this.searchType == 1) {
      this.totalTemp = this.searchKey
      this.getCountrys()
      let country = localStorage.getItem("countries");
      if (country) {
        this.country = JSON.parse(country);
      } else {
        this.country = [];
      }
    }
    if(this.searchType&&this.searchType == 3) {
      this.textData = this.searchKey
    }
    //this.getHistory()
  },
  methods: {
    handleChange(val) {
      if (val == 0) {
        //this.getCountrys();
      }
      if (val == 1) {
       // this.getCountrys();
        let country = localStorage.getItem("countries");
        if (country) {
          this.country = JSON.parse(country);
        } else {
          this.country = [];
        }
      }
    },
    // getCountrys() {
    //   alert(23213)
    //   let list = this.rspnation.split(";;;");
    //   this.list = list;
    //   debugger
    //   console.log(this.list)
    //   list.forEach((item) => {
    //     let c = {
    //       name: getPnc(item),
    //       code: item,
    //     };
    //     this.cList.push(c);
    //   });
    // },
    goHistory() {
      this.$router.push({
        path: '/user/history'
      })
    }
  },
}
</script>

<style scoped>
.btn{
  padding: 0 12px;
}
</style>